import { CartAddEvent } from '@theme/events';
class DGCartExtra extends HTMLElement {
  static pending = false;
  connectedCallback() { this.addEventListener('click', this.onClick); }
  disconnectedCallback() { this.removeEventListener('click', this.onClick); }
  onClick = async (event) => {
    const button = event.target.closest('[data-dg-add]');
    if (!button || !this.contains(button) || DGCartExtra.pending || document.querySelector('.cart-items-disabled')) return;
    event.preventDefault();
    event.stopPropagation();
    const status = this.querySelector('[data-dg-status]');
    const idleText = button.textContent;
    DGCartExtra.pending = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = this.dataset.loading;
    status.textContent = '';
    const components = [...document.querySelectorAll('cart-items-component')];
    const sections = [...new Set(components.map(el => el.dataset.sectionId).filter(Boolean))].slice(0,5);
    components.forEach(el => el.classList.add('cart-items-disabled'));
    try {
      const response = await fetch(this.dataset.addUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: button.dataset.variantId, quantity: 1 }], sections, sections_url: window.location.pathname }),
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || this.dataset.error);
      status.textContent = this.dataset.success;
      document.dispatchEvent(new CartAddEvent(data, 'dg-cart-extra', {
        source: 'dg-cart-extra', variantId: button.dataset.variantId, sections: data.sections
      }));
    } catch (error) {
      status.textContent = error.message || this.dataset.error;
    } finally {
      DGCartExtra.pending = false;
      components.forEach(el => el.classList.remove('cart-items-disabled'));
      document.querySelectorAll('cart-items-component').forEach(el => el.classList.remove('cart-items-disabled'));
      if (button.isConnected) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = idleText;
      }
    }
  };
}
if (!customElements.get('dg-cart-extra')) customElements.define('dg-cart-extra', DGCartExtra);
